import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.RecertApplicationForm.title',
    defaultMessage: 'Recert Application',
  },
  save: {
    id: 'App.RecertApplicationForm.save',
    defaultMessage: 'Save',
  },
  saveSuccess: {
    id: 'App.RecertApplicationForm.saveSuccess',
    defaultMessage: 'Recert Application progress saved.',
  },
  invalidForm: {
    id: 'App.RecertApplicationForm.invalidForm',
    defaultMessage: 'Some fields are invalid. Fix them to save.',
  },
  blockingAnswers: {
    id: 'App.RecertApplicationForm.blockingAnswers',
    defaultMessage:
      'Answer the highlighted questions to confirm the signed copy.',
  },
  saveError: {
    id: 'App.RecertApplicationForm.saveError',
    defaultMessage: 'Failed to save the Recert Application.',
  },
  loadError: {
    id: 'App.RecertApplicationForm.loadError',
    defaultMessage: 'Failed to load the Recert Application.',
  },
  print: {
    id: 'App.RecertApplicationForm.print',
    defaultMessage: 'Print',
  },
  printError: {
    id: 'App.RecertApplicationForm.printError',
    defaultMessage: 'Failed to print the Recert Application.',
  },
  saved: {
    id: 'App.RecertApplicationForm.saved',
    defaultMessage: 'Saved',
  },
  unsavedChanges: {
    id: 'App.RecertApplicationForm.unsavedChanges',
    defaultMessage: 'Unsaved changes',
  },
  lastSavedToday: {
    id: 'App.RecertApplicationForm.lastSavedToday',
    defaultMessage: 'Last saved today at {time}',
  },
  lastSavedYesterday: {
    id: 'App.RecertApplicationForm.lastSavedYesterday',
    defaultMessage: 'Last saved yesterday at {time}',
  },
  lastSavedOn: {
    id: 'App.RecertApplicationForm.lastSavedOn',
    defaultMessage: 'Last saved {date} at {time}',
  },
  closeConfirmTitle: {
    id: 'App.RecertApplicationForm.closeConfirmTitle',
    defaultMessage: 'Save before closing?',
  },
  closeConfirmBody: {
    id: 'App.RecertApplicationForm.closeConfirmBody',
    defaultMessage:
      "This application has changes that haven't been saved. " +
      'If you close now, they will be lost. Save and close to keep them.',
  },
  closeWithoutSaving: {
    id: 'App.RecertApplicationForm.closeWithoutSaving',
    defaultMessage: 'Close without saving',
  },
  saveAndClose: {
    id: 'App.RecertApplicationForm.saveAndClose',
    defaultMessage: 'Save & Close',
  },
  printConfirmTitle: {
    id: 'App.RecertApplicationForm.printConfirmTitle',
    defaultMessage: 'Print an outdated version?',
  },
  printConfirmBody: {
    id: 'App.RecertApplicationForm.printConfirmBody',
    defaultMessage:
      "This application has changes that haven't been saved, so the printed document won't include them.",
  },
  printAnyway: {
    id: 'App.RecertApplicationForm.printAnyway',
    defaultMessage: 'Print anyway',
  },
  saveAndPrint: {
    id: 'App.RecertApplicationForm.saveAndPrint',
    defaultMessage: 'Save & Print',
  },
  close: {
    id: 'App.RecertApplicationForm.close',
    defaultMessage: 'Close',
  },
});

export default messages;
